import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M38.75 16.25a5 5 0 0 0-8.266-3.781c-2.625-1.39-5.75-2.235-9.015-2.422l.812-4.875 3.407.531a3.78 3.78 0 1 0 .39-2.469l-4.64-.718a1.25 1.25 0 0 0-1.422 1.03l-1.078 6.485c-3.407.14-6.688.985-9.422 2.438a5 5 0 0 0-6.657 7.453A9.6 9.6 0 0 0 2.5 22.5c0 3.422 1.875 6.625 5.297 8.984S15.407 35 20 35c4.594 0 8.922-1.25 12.203-3.516S37.5 25.922 37.5 22.5a9.4 9.4 0 0 0-.36-2.562 5.06 5.06 0 0 0 1.61-3.688m-27.5 4.375a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m14.484 7.984a12.52 12.52 0 0 1-11.468 0 1.25 1.25 0 0 1 1.14-2.218 10.03 10.03 0 0 0 9.188 0 1.25 1.25 0 0 1 1.14 2.218m.516-5.484a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }